import { DATE_TIME } from '../constants/dates';
import dateFormatter from './dateFormatter';

export default function dateTime(date: any, timeZone: any) {
  return dateFormatter(date, DATE_TIME, timeZone);
}
